export enum ESettingsTab {
  Account = 'account',
  Subdivision = 'subdivision',
  Contract = 'contract',
}

export enum ESettingsMenuTab {
  Contracts = 'contracts',
  UserList = 'user-list',
  LegalEntityList = 'legal-entity-list',
  StockList = 'stock-list',
  Integrations = 'integrations',
  General = 'general',
  AddressList = 'address-list',
  Assortment = 'assortment',
  DiscountList = 'discount-list',
  DeliveryTimeList = 'delivery-time-list',
  PersonalLimits = 'personal-limits',
}
